import {CancelTokenSource} from "axios";

export class InternalChatUsersListFilters {
    searchParam: string;
    page: number;
    limit: number;
    idInternalChat: string;
    cancelTokenSource?: CancelTokenSource;

    constructor(params: {
        searchParam: string;
        page: number;
        limit: number;
        idInternalChat: string;
        cancelTokenSource?: CancelTokenSource;
    }) {
        this.searchParam = params.searchParam;
        this.page = params.page;
        this.limit = params.limit;
        this.idInternalChat = params.idInternalChat;
        this.cancelTokenSource = params.cancelTokenSource;
    }
}
